import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function RegularIncomePage() {
  return (
    <PortfolioUniversePage
      strategyId="regular-income"
      portfolioHoldingType="REGULAR_INCOME"
    />
  );
}
